import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { selectMemberBins } from '../../../../../../Member/MemberBins/selectors/foldersSelectors';
import Tooltip from '../../../../../../builder-io/storyblocks-design-system/components/atoms/Tooltip/Tooltip';
import { default as FavoriteButtonIcon } from '../../../../../../common/components/FavoriteButton';
import {
  convertStockItemContextToOriginArea,
  isStockItemInAnyFolder,
} from '../../../../../../common/utils';
import { VideoStockItemCardProps } from '../../VideoStockItemCard';

export interface FavoriteButtonProps
  extends Pick<
    VideoStockItemCardProps,
    | 'stockItem'
    | 'stockItemFormats'
    | 'favoriteButtonTelemetryAction'
    | 'containPoppers'
    | 'openFoldersInNewWindow'
    | 'context'
  > {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}
export const FavoriteButton = ({
  context,
  stockItem,
  stockItemFormats,
  favoriteButtonTelemetryAction,
  containPoppers,
  openFoldersInNewWindow,
  onClick,
}: FavoriteButtonProps) => {
  const memberBins = useSelector(selectMemberBins);
  const bins = memberBins ? Object.values(memberBins) : [];

  const [showTooltip, setShowTooltip] = useState(false);

  const tooltipText = isStockItemInAnyFolder(bins, stockItem)
    ? 'Added to Folder'
    : 'Add to Folder';

  const fireFavoriteButtonTelemetryFromParent = () => {
    favoriteButtonTelemetryAction?.();
  };

  const originArea = convertStockItemContextToOriginArea(context);

  return (
    <Tooltip
      title={tooltipText}
      open={showTooltip}
      trigger={
        <div
          className="action-wrapper button-sizing"
          onMouseEnter={() => setShowTooltip(true)}
          onFocus={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onBlur={() => setShowTooltip(false)}
        >
          <FavoriteButtonIcon
            onButtonClick={() => {
              fireFavoriteButtonTelemetryFromParent();
              setShowTooltip(false);
            }}
            onClickAction={onClick}
            stockItem={stockItem}
            stockItemFormats={stockItemFormats}
            telemetryKey="search"
            iconClassName="w-4 h-4"
            containPoppers={containPoppers}
            openFoldersInNewWindow={openFoldersInNewWindow}
            originArea={originArea}
            buttonClasses="text-white bg-gray-900 w-10 h-10 rounded-full p-3 hover:bg-opacity-90 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-white"
          />
        </div>
      }
    />
  );
};
